import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoggerService } from './logger.service';

var TAG = "DialogReplyService";


@Injectable({
    providedIn: 'root'
})

export class DialogReplyService {

    private dialogReply = new BehaviorSubject('');
    current_dialogReply = this.dialogReply.asObservable();

    constructor(private log: LoggerService
    ) { }

    doDialogReply(reply: string) {
        this.log.d(TAG, 'Replied: ' + reply);
        this.dialogReply.next(reply);
        // this.dialogReply.complete();
      }

    doDialogReplyCompleted() {
        this.log.d(TAG, 'Replied Completed');
        this.dialogReply.next('');
        // this.dialogReply.complete();
      }
}
